export const formatVehicleLabel = vehicle => {
  if (!vehicle) {
    return '';
  }
  const vehicleNo = vehicle.vehicle_no ?? '';
  const vehicleType = vehicle.vehicle_type ?? '';
  if (vehicleNo && vehicleType) {
    return `${vehicleNo} - ${vehicleType}`;
  }
  return `${vehicleNo || vehicleType}`;
};

export const getVehiclesFromIdsResponseData = response => {
  if (response?.data?.status !== 'SUCCESS') {
    return [];
  }
  return response.data.data?.data ?? [];
};

export const buildVehicleLabelMap = vehicles => {
  const map = {};
  (vehicles || []).forEach(vehicle => {
    const id = parseInt(vehicle.id ?? vehicle.vehicle_id, 10);
    if (!Number.isFinite(id) || id <= 0) {
      return;
    }
    map[id] = formatVehicleLabel(vehicle);
  });
  return map;
};

export const getVehicleLabelForDriver = (activeDriverList, driverId, fallbackLabel = '') => {
  const activeDriver = activeDriverList?.find(driver => String(driver.id) === String(driverId));

  if (activeDriver?.vehicle) {
    return activeDriver.vehicle;
  }

  if (activeDriver?.vehicle_no && activeDriver?.vehicle_type) {
    return `${activeDriver.vehicle_no} - ${activeDriver.vehicle_type}`;
  }

  if (fallbackLabel && `${fallbackLabel}` !== '-1') {
    return `${fallbackLabel}`;
  }

  return '';
};
